__turbopack_context__.v({
  "actions": "wsVMna_actions",
  "banner": "wsVMna_banner",
  "content": "wsVMna_content",
  "description": "wsVMna_description",
  "error": "wsVMna_error",
  "icon": "wsVMna_icon",
  "info": "wsVMna_info",
  "success": "wsVMna_success",
  "title": "wsVMna_title",
  "warning": "wsVMna_warning",
});
